import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { PdfIcon, PptIcon, XlsIcon, WordIcon, } from '@/components/ui/SvgIcon/Static/SvgIconComponents';
import { AttachFileIcon } from '@/components/ui/SvgIcon/Variable/SvgIconComponents';
/**
 * ファイル拡張子の文字列（例：pptx,pdfなど）に対応するアイコンを表示するコンポーネント
 * @param props
 * @constructor
 */
export const FileExtension = (props) => {
    const { className = '', color = 'base', extension: propExtension, size, } = props;
    const extension = useMemo(() => (propExtension || '').toLowerCase(), [propExtension]);
    // パワーポイント
    if (['pptx', 'ppt'].includes(extension)) {
        return _jsx(PptIcon, { className: className, size: size });
    }
    // エクセル
    if (['xlsx', 'xls'].includes(extension)) {
        return _jsx(XlsIcon, { className: className, size: size });
    }
    // ワード
    if (['docx', 'doc'].includes(extension)) {
        return _jsx(WordIcon, { className: className, size: size });
    }
    // PDF
    if (['pdf'].includes(extension)) {
        return _jsx(PdfIcon, { className: className, size: size });
    }
    // その他（クリップアイコン）
    return _jsx(AttachFileIcon, { className: className, color: color, size: size });
};
